module.exports = __webpack_public_path__ + "static/bathroom-e0ef375b38f9e22df296fa13e6a94013.jpg";